export default __webpack_public_path__ + "static/media/mainCoursePh.b851d618.png";